<template>
	<div class="q_pad_lr15px q_mar_t15px">
<!--		<div class="q_po_re">-->
<!--			<van-image class="q_speed_bg" fit="cover" :src="require('../../assets/image/cert_acti.jpg')" />-->
<!--			<div class="q_po_ab" style="top: 40vw;left: 0;padding: 0 13vw;">-->
<!--				<div class="q_center">证书编号 <span class="q_text_m q_bold" v-text="data.certificateNo">D423425258223</span></div>-->
<!--				<div class="q_mar_t30px"><span class="q_pad_lr15px q_bor_bottom q_bold"-->
<!--                                       style="border-color: #333333;" v-text="data.userName">张三</span>{{data.userSex == '0' ? '先生' : data.sex == '1' ? '女士' : '未知'}}</div>-->
<!--				<div class="q_mar_t15px q_justify">感谢您参与【-->
<!--					<span class="q_bold" v-text="data.projectName">“以爱之名 携手同行”助残日志愿服务活动</span>】项目。大爱无疆，感谢您让世界更美好。-->
<!--				</div>-->
<!--				<div class="q_mar_t20px">特颁此证！</div>-->
<!--				<div class="q_mar_t20px q_right">-->
<!--					<div v-text="data.deptName">金太阳志愿者协会</div>-->
<!--					<div v-text="data.grantTime">2022年6月18日</div>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->


    		<div class="q_po_re">
    			<van-image class="q_speed_bg" fit="cover" :src="url" />
    		</div>

    <!--志愿者证书-->
    <div v-if="isShow" style="width:905px;height:640px;margin-left:auto;margin-right:auto;" class="zsbox" id="downdata"
         ref="exportPdf"
    >
      <div id="zs"
           :style="activityStyle"
      >
        <div class="p1"
             style="top: 237px;width: 100%;text-align: center;font-size: 28px;font-family: sans-serif;font-weight: bold;position: absolute;color: black;"
        >
          {{ data.userName }}
        </div>

        <div class="p1"
             style="left: 335px;top: 302px;font-family: sans-serif;font-size: 21px;position: absolute;text-align: center;width: 210px;color: black;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;overflow: hidden;"
        >
          {{ data.projectName }}
        </div>

        <div class="p1" style="left:603px;top:485px;position: absolute;font-size: 18px;color: black;">
          {{ parseTime(data.grantTime, '{y}/{m}/{d}') }}
        </div>

        <div class="p1" style="left: 430px; top: 64px;font-size: 18px;position: absolute;color: black;">
          {{ data.certificateNo }}
        </div>
      </div>
    </div>


<!--		<div class="q_vertical_left q_mar_t15px" style="width: 100%" @click="goToActivdea()">-->
<!--			<div class="q_inlineblock">-->
<!--				&lt;!&ndash; <van-image class="q_speed_img" fit="cover" src="https://jtkji.com/uni_image/ls1.png" /> &ndash;&gt;-->
<!--				<van-image class="q_speed_img" fit="cover" :src="data.banner" />-->
<!--			</div>-->
<!--			<div class="q_mar_l15px q_inlineblock" style="width: 100%;">-->
<!--				<div class="q_text_m q_bold q_moit2 q_justify" v-text="data.name">“以爱之名 携手同行”助残日志愿服务活动</div>-->
<!--&lt;!&ndash;				<div class="q_mar_t15px">&ndash;&gt;-->
<!--&lt;!&ndash;					<div class="q_text_s q_color_gray q_moit2" v-text="data.description">活动简介活动简介活动简介活动简介活动简介活动简介活动简介活动简介活动简介</div>&ndash;&gt;-->
<!--&lt;!&ndash;					&lt;!&ndash; <div class="q_text_s q_color_gray q_mar_t3px">2022-04-18 08:00~17:00</div> &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;					<div class="q_text_s q_color_gray q_mar_t3px">{{data.activity_start_time}}~{{data.activity_end_time}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;				</div>&ndash;&gt;-->
<!--			</div>-->
<!--		</div>-->
	</div>
</template>

<script>
import {certificateById} from "@/api/certificate";
import {parseTime, wxCloseShare} from "@/utils/jiutang";
import zsbj from '@/assets/image/zsbj.png'
import html2canvas from 'html2canvas';
export default {
  name: 'Foracti',
  props: {
    msg: String
  },
  data() {
    return {
      isShow:true,
      activityStyle: 'position:relative;width:905px;height:640px;background:url(' + zsbj + ');background-size:905px 640px;margin-left:auto;margin-right:auto;',
      pageParam: {
        id: ''
      },
      data: {},
      url :''
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading()
    this.pageParam.id = this.$route.query.id;
    certificateById(this.$route.query.id).then(res => {
      this.data = res.data;
      // console.log("数据结果" + JSON.stringify(res.data))
    }).finally(() => {
      this.pdf()
      this.$modal.closeLoading()
    })
  },
  methods: {
    goToActivdea() {

      this.$router.push({
        path: '/activity/Activdea', query: {id: this.data.id}
      });
    },
    parseTime(time) {
      return parseTime(time,'{y}-{m}-{d}')
    },
    pdf(){
      html2canvas(this.$refs.exportPdf, {
        backgroundColor: '#ffffff',
        useCORS: true,
        // width: window.screen.availWidth,
        // height: window.screen.availHeight,
        windowHeight: document.body.scrollHeight,
        y: window.pageYOffset
      }).then((canvas) => {
        this.url = canvas.toDataURL()
        this.isShow = false
      })
    }
  },
}
</script>
<style scoped="scoped">
.q_speed_img {
  width: 110px;
  height: 110px;
}

.q_speed_img >>> .van-image__img {
  border-radius: 5px;
}

.q_speed_b {
  background-color: #F2F3F7;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  position: relative;
}

.q_speed_t {
  background-color: #FF5733;
  width: 10%;
  height: 6px;
  border-radius: 3px;
  position: absolute;
  top: 0px;
  left: 0;
}

.q_speed_bg {
  width: 100%;
}
</style>
